import * as React from 'react';
import { Typography } from '@mui/material';
import {
  format,
  addDays,
  subDays,
  addMonths,
  subMonths,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  addWeeks,
  subWeeks,
} from 'date-fns';
import './navigation.css';

interface Props {
  storageKey: string;
  selectedDate: Date;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date>>;
  currentView: string;
}

function DateNav({
  storageKey,
  selectedDate,
  setSelectedDate,
  currentView,
}: Props) {
  const [displayStartDate, setDisplayStartDate] = React.useState(selectedDate);
  const [displayEndDate, setDisplayEndDate] = React.useState(selectedDate);

  React.useEffect(() => {
    if (currentView === 'week') {
      setDisplayStartDate(startOfWeek(selectedDate));
      setDisplayEndDate(endOfWeek(selectedDate));
    }

    if (currentView === 'list') {
      setDisplayEndDate(addDays(selectedDate, 7));
    }
  }, [currentView, selectedDate]);

  const nextDates = () => {
    const adjustDate = (date: Date) => {
      if (currentView === 'month') return addMonths(startOfMonth(date), 1);
      if (currentView === 'week') return addWeeks(startOfWeek(date), 1);
      if (currentView === 'day') return addDays(date, 1);
      return addDays(date, 7);
    };

    const newDate = adjustDate(selectedDate);
    setSelectedDate(newDate);
    if (storageKey) sessionStorage.setItem(storageKey, newDate.toISOString());
  };

  const prevDates = () => {
    const adjustDate = (date: Date) => {
      if (currentView === 'month') return subMonths(startOfMonth(date), 1);
      if (currentView === 'week') return subWeeks(startOfWeek(date), 1);
      if (currentView === 'day') return subDays(date, 1);
      return subDays(date, 7);
    };

    const newDate = adjustDate(selectedDate);
    setSelectedDate(newDate);
    if (storageKey) sessionStorage.setItem(storageKey, newDate.toISOString());
  };

  return (
    <div className="date-nav">
      <button className="date-nav-arrow" onClick={prevDates} type="button">
        <img className="chevron-left" src="/chevron-down.svg" alt="back" />
      </button>
      <div className="date-nav-content">
        {currentView === 'list' && (
          <Typography
            variant="body1"
            style={{
              fontSize: '0.875rem',
              fontWeight: 500,
            }}>
            {format(selectedDate, 'MMM d')} - {format(displayEndDate, 'MMM d')}
          </Typography>
        )}
        {currentView === 'week' && (
          <Typography
            variant="body1"
            style={{
              fontSize: '0.875rem',
              fontWeight: 500,
            }}>
            {format(displayStartDate, 'MMM d')} -{' '}
            {format(displayEndDate, 'MMM d')}
          </Typography>
        )}
        {currentView === 'month' && (
          <Typography
            variant="body1"
            style={{
              fontSize: '0.875rem',
              fontWeight: 500,
            }}>
            {format(selectedDate, 'MMMM')}
          </Typography>
        )}
        {currentView === 'day' && (
          <Typography
            variant="body1"
            style={{
              fontSize: '0.875rem',
              fontWeight: 500,
            }}>
            {format(selectedDate, 'eeee, MMM d')}
          </Typography>
        )}
      </div>
      <button className="date-nav-arrow" onClick={nextDates} type="button">
        <img className="chevron-right" src="/chevron-down.svg" alt="next" />
      </button>
    </div>
  );
}

export default DateNav;
